<template>
  <fragment>
    <div class="confectionModal">
      <div class="confectionModal-top">
        <img
          class="confectionModal-image img-responsive mx-auto"
          alt="envelope example"
          :src="image"
        />
      </div>

      <div class="confectionModal-content">
        <h2 class="confectionModal-title">Personalizacja na maxa</h2>
        <section class="confectionModal-descriptions">
          <p>
            Dodatkowe opcje personalizacji Twojej firmy w aplikacji Pluxee i serwisie pluxee.pl dla
            użytkowników kart - nazwa firmy, logo oraz powód przekazania wyświetlą się użytkownikom
            po dodaniu karty do aplikacji.
          </p>
        </section>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'NDEAppConfectionModal',
  props: {
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.confectionModal {
  &-top {
    background-color: #def3fb;
    &::after {
      border-color: #def3fb rgba(0, 0, 0, 0) rgba(0, 0, 0, 0) rgba(0, 0, 0, 0);
    }
  }
  &-descriptions {
    font-size: 1.7rem;
  }
}
</style>
